// @ts-check

import { AUTO_INITIALIZED_COMPONENTS } from './autogenerated-imports'
import ComponentHandler from './component-handler'
class App {
  constructor() {
    // init all components
    this.componentHandler = new ComponentHandler({ components: AUTO_INITIALIZED_COMPONENTS });
    // console.log('initilized app')
  }
}

new App()